// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"388":"47dd09f9","556":"67a2d8aa","770":"25c28a06","890":"cd3ecf24"}[chunkId] + ".chunk.js";
};